<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
export default {
  data() {
    return {
      drawTiming: null,
      cdata: {
        xData: ['非法装卸', '船舶超载', '配员不足', '燃油超标', '遮挡船名牌', '超尺度航行', '未穿救生衣', '其他'],
        seriesData: [
          { value: 10, name: '非法装卸' },
          { value: 5, name: '船舶超载' },
          { value: 15, name: '配员不足' },
          { value: 25, name: '燃油超标' },
          { value: 20, name: '遮挡船名牌' },
          { value: 20, name: '超尺度航行' },
          { value: 35, name: '未穿救生衣' },
          { value: 10, name: '其他' }
        ]
      }
    }
  },
  components: {
    Chart
  },
  mounted() {
    this.drawTimingFn()
  },
  beforeDestroy() {
    clearInterval(this.drawTiming)
  },
  methods: {
    drawTimingFn() {
      this.setData()
      this.drawTiming = setInterval(() => {
        this.setData()
      }, 6000)
    },
    setData() {
      this.cdata.seriesData.forEach(item => {
        let r = Math.round(Math.random() * 5)
        item.value += r % 2 ? r : -1 * r
      })
    }
  }
}
</script>
